import type { UpdateSupplierSettingsInput } from '@repo/api-contracts';
import { useState } from 'react';
import { useInvalidateSupplierSettings } from '@/entities/supplier-setting';
import { trpc } from '@/shared/api';
import { getErrorMessage } from '@/shared/lib';

export const useUpdateSupplierSettings = () => {
  const [error, setError] = useState<string | null>(null);
  const settings = useInvalidateSupplierSettings();
  const mutation = trpc.supplierSettings.update.useMutation({
    onSuccess: (data) => {
      settings.setData(data);
      return settings.invalidate();
    },
  });
  const update = async (input: UpdateSupplierSettingsInput): Promise<boolean> => {
    setError(null);
    try {
      await mutation.mutateAsync(input);
      return true;
    } catch (cause) {
      setError(getErrorMessage(cause, '사업자·입금 계좌 설정을 저장하지 못했습니다.'));
      return false;
    }
  };
  return { update, isPending: mutation.isPending, error };
};
